import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import DueMonthly from '../../common/MiniCart/redesign/desktopCart/dueMonthly';

import { getAPPID, getUrlName, isWWM } from '../../common/Helpers';
import { isDisplayOneTimeCharges } from '../../common/MiniCart/MiniCartUtils';
import OneTimeChargesDiscounts from '../../common/MiniCart/redesign/component/OneTimeChargesDiscounts';

const MCartDueMonthly = (props) => {
  useEffect(() => {
    const { cartData, getCartDataFromApi } = props;
    if (cartData?.cartDetailsJson?.dueTodayList?.length <= 0) {
      getCartDataFromApi();
    }
  }, []);

  const { isCartVisible, plansReferenceData } = props;
  const selectedSetupChoices = props?.cartData?.cartDetailsJson?.orderDetailsView?.installType;

  const pathName = window?.location?.pathname || props?.location?.pathName;
  const currentPageName = getUrlName(pathName);
  const isOneTimeCharges = isDisplayOneTimeCharges(currentPageName, selectedSetupChoices);
  let showDueMonthly = true;
  if(window.location.href.indexOf("orderreview") > 0 && isWWM()){
    showDueMonthly = false;
  }
  return (
    <>
      { showDueMonthly && <DueMonthly {...props} />}
      {isCartVisible && <OneTimeChargesDiscounts plansReferenceData={plansReferenceData} isOneTimeCharges={isOneTimeCharges} appId={getAPPID()} />}
    </>
  );
};

export default MCartDueMonthly;

MCartDueMonthly.propTypes = {
  getCartDataFromApi: PropTypes.func,
  isCartVisible: PropTypes.bool,
  cartData: PropTypes.object,
  plansReferenceData: PropTypes.any,
  location: PropTypes.any,
};
